import Vue from 'vue'
import VueResource from 'vue-resource'
import { VueAuthenticate } from 'vue-authenticate'
import appConfig from '@/config.js'
Vue.use(VueResource)

// Hosts que reciben el Bearer del admin. Meli NO va acá: manda su propio
// `Authorization: application.key` (api.service.js) y el guard `has()` lo respeta.
// Mandar el Bearer a otros hosts (tiles CloudFront/Mapbox, router API) fuerza un
// preflight con `authorization` que esos hosts rechazan -> CORS error.
const authenticatedBaseUrls = [appConfig.api.baseUrl].filter(Boolean)
const needsAuthHeader = url => authenticatedBaseUrls.some(baseUrl => url.includes(baseUrl))

const vueAuthInstance = new VueAuthenticate(Vue.http, {
  baseUrl: appConfig.api.baseUrl,
  loginUrl: '/login',
  registerUrl: '/users',
  logoutUrl: '/logout',
  refreshUrl: '/login/refresh',
  requestDataKey: 'body',
  storageNamespace: 'moova.io',
  tokenPrefix: 'auth',
  refreshType: 'storage',
  refreshTokenPrefix: 'auth',
  expirationPrefix: 'auth',
  bindRequestInterceptor: function ($auth) {
    const interceptor = function (request, next) {
      if (!request.headers.has('Authorization')) {
        if ($auth.isAuthenticated() && needsAuthHeader(request.url)) {
          request.headers.set('Authorization', [
            $auth.options.tokenType, $auth.getToken()
          ].join(' '))
        } else {
          request.headers.delete('Authorization')
        }
      }
      next(async function (response) {
        if (request.url.includes(appConfig.api.baseUrl)) {
          if (response.status === 401 && $auth.options.refreshType && $auth.isTokenSet()) {
            // check if we are already refreshing, to prevent endless loop
            if (!$auth._isRefreshing) {
              $auth._isRefreshing = true
              // Try to refresh our token
              return await $auth.refresh()
                .then(function (response) {
                  // refreshing was successful :)
                  $auth._isRefreshing = false
                  // full reload the page
                  window.location.reload()
                })
                .catch(async function (error) {
                  console.error(error)
                  // Refreshing fails :(
                  $auth._isRefreshing = false
                  // Imports diferidos para no crear el ciclo services/auth ->
                  // store/router -> services/auth en la carga inicial (el
                  // orden de evaluación dejó de garantizarlo al hacer lazy
                  // las rutas); eager = mismo bundle, sin chunk extra.
                  const { default: store } = await import(/* webpackMode: "eager" */ '@/store')
                  const { default: router } = await import(/* webpackMode: "eager" */ '@/router')
                  store.dispatch('logout')
                  router.push({ name: 'login' })
                })
            }
          }
        }
        return response
      })
    }

    this.$http.interceptors.push(interceptor)
  },

  providers: {
    facebook: {
      clientId: appConfig.auth.facebook.clientId,
      url: appConfig.api.baseUrl + 'oauth/social/facebook?country_iso_code=' + document.cookie.split('; ').reduce((r, v) => {
        const parts = v.split('=')
        return parts[0] === 'country' ? decodeURIComponent(parts[1]) : r
      }, ''),
      redirectUri: window.location.origin + '/oauth',
      responseType: 'token',
      defaultUrlParams: ['response_type', 'client_id', 'redirect_uri', 'access_token'],
      responseParams: {
        'accessToken': 'access_token'
      }
    },
    google: {
      clientId: appConfig.auth.google.clientId,
      url: appConfig.api.baseUrl + 'oauth/social/google?country_iso_code=' + document.cookie.split('; ').reduce((r, v) => {
        const parts = v.split('=')
        return parts[0] === 'country' ? decodeURIComponent(parts[1]) : r
      }, ''),
      redirectUri: window.location.origin + '/oauth',
      responseType: 'token',
      defaultUrlParams: ['response_type', 'client_id', 'redirect_uri', 'access_token'],
      responseParams: {
        'accessToken': 'access_token'
      }
    }
  }
})

export default vueAuthInstance
